import { motion } from "framer-motion";

export const ArtistCard = ({ artist, index, featured = false }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 48 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay: index * 0.12, ease: [0.16, 1, 0.3, 1] }}
      className={`group relative overflow-hidden border border-white/10 bg-tile ${
        featured ? "lg:col-span-2 lg:row-span-2" : ""
      }`}
      data-testid={`artist-card-${artist.id}`}
    >
      <div className="relative aspect-[4/5] overflow-hidden">
        <img
          src={artist.image}
          alt={artist.name}
          className="absolute inset-0 w-full h-full object-cover grayscale contrast-125 transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent" />
        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 mix-blend-color-dodge bg-blood/20" />
        <span className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-[0.2em] text-acid border border-acid/50 px-2 py-1 bg-black/60">
          {artist.tag}
        </span>
      </div>
      <div className="p-5 sm:p-6">
        <div className="flex flex-col gap-1">
          <h3 className="font-display font-extrabold uppercase text-2xl sm:text-3xl tracking-tight text-foreground leading-none">
            {artist.name}
          </h3>
          <span className="font-mono text-xs text-zinc-500">
            {artist.origin}
          </span>
        </div>
        <p className="mt-3 text-sm text-zinc-400 leading-relaxed font-body">
          {artist.bio}
        </p>
      </div>
    </motion.div>
  );
};
